import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchCustomers, selectCustomer } from '../../actions/customers_actions';
import {
  fetchSalesInvoices,
  fetchSalesInvoicesByNum,
  fetchSalesInvoicesCompleted,
  resetCurrentSalesInvoice,
  resetCurrentSalesInvoicePromise,
  selectSalesInvoice,
} from '../../actions/salesInvoice_actions';
import { setDefaultDays } from '../../actions/purchaseOrders_actions';
import { setValue } from '../../actions/sales_actions';
import CustomerReturn from '../../components/Returns/customerReturn';

const customerReturn = reduxForm({
  form: 'customerReturn',
})(CustomerReturn);

const selector = formValueSelector('customerReturn');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FormTypes = selector(state, 'FormTypes');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const Customers = selector(state, 'Customers');
  const Invoice_num = selector(state, 'Invoice_num');
  const InvoiceNum = selector(state, 'InvoiceNum');

  return {
    Days,
    FormTypes,
    FromDate,
    ToDate,
    Customers,
    Invoice_num,
    InvoiceNum,

    customers: state.customers.all,
    customersIsLoading: state.customers.isLoading,
    customersError: state.customers.error,

    salesInvoice: state.salesInvoice.completed,
    isLoading: state.salesInvoice.completedIsLoading,
    error: state.salesInvoice.completedError,
  };
}

export default connect(mapStateToProps, {
  setDefaultDays,
  fetchSalesInvoices,
  fetchSalesInvoicesByNum,
  fetchCustomers,
  selectCustomer,
  fetchSalesInvoicesCompleted,
  resetCurrentSalesInvoice,
  resetCurrentSalesInvoicePromise,
  selectSalesInvoice,
  setValue,
})(customerReturn);



// WEBPACK FOOTER //
// ./master/jsx/containers/Returns/customerReturn.jsx